import { Slide, Snackbar as SnackbarUI } from '@material-ui/core';
import React, { useEffect,  useState } from 'react';
import ReactDOM from 'react-dom';
import './alert.css';

const container = document.createElement('div');
container.setAttribute('id', 'alert');
container.style.position = 'absolute';
container.style.top = 0;
container.style.left = 0;

export default function Snackbar(content) {

  document.getElementById('root').appendChild(container);

  // ReactDOM.render(<AlertElement content={content} />, container);
  const onClose = () => {
    ReactDOM.render(<AlertElement content={null} />, container);
  }

  ReactDOM.render(<AlertElement content={content} onClose={onClose} />, container);
}

const AlertElement = ({ content, onClose = () => { } }) => {
  // const Ball = useRef(null);
  const [Open, setOpen] = useState(false);

  useEffect(() => {
    // console.log('holaaaaaaaaaaaa', content);
    if (content) setOpen(true);
  }, [content])

  const _onClose = () => {
    // setOpen(false);
    onClose();
  }

  return (
    <SnackbarUI TransitionComponent={Slide} message={content} open={Open && content ? true : false} onClose={_onClose} />
  )
}